import { useState } from 'react'

import { GetServerSideProps, NextPage } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'

import { Status, Wrapper } from '@googlemaps/react-wrapper'
import { useInterval } from 'react-use'

import { restaurantGetRestaurant } from '~/api-client/food_api/restaurant'
import { Restaurant } from '~/api-definition/definition'
import { Button } from '~/components/action/Button'
import { Map, Marker } from '~/components/food_app/restaurant/Map'
import { ChevronLeftIcon } from '~/components/icons'
import { Footer } from '~/components/layout/Footer'
import { Header } from '~/components/layout/Header'
import { config } from '~/config'

type Props = {
  restaurant: Restaurant
}

const Page: NextPage<Props> = (props) => {
  const router = useRouter()
  const [center, setCenter] = useState<{ lat: number; lng: number } | null>(
    null
  )

  useInterval(
    () => {
      if (center) {
        return
      }
      if (props.restaurant.latitude && props.restaurant.longitude) {
        setCenter({
          lat: Number(props.restaurant.latitude),
          lng: Number(props.restaurant.longitude),
        })
        return
      }
    },
    center ? null : 1000
  )

  return (
    <>
      <Head>
        <title>アクセス情報</title>
      </Head>
      <Header>
        <ChevronLeftIcon fill="#fff" onClick={() => router.back()} />
        <div />
        アクセス情報
        <div></div>
        <div />
      </Header>
      <div>
        {!props.restaurant.address && (
          <div className="text-center text-black text-sm">
            <p>住所情報はありません</p>
          </div>
        )}

        {props.restaurant.address && (
          <>
            {props.restaurant.latitude != null &&
              props.restaurant.latitude.length > 0 &&
              props.restaurant.longitude != null &&
              props.restaurant.longitude.length > 0 && (
                <div className="relative w-full h-96">
                  <div style={{ display: 'flex', height: '100%' }}>
                    <Wrapper
                      apiKey={config.googleMap.apiKey}
                      render={(status: Status) => {
                        return <h1>{status}</h1>
                      }}
                    >
                      <Map
                        center={center}
                        zoom={14}
                        disableDefaultUI={true}
                        style={{ flexGrow: '1', height: '100%' }}
                      >
                        <Marker key={'marker'} position={center} />
                        <Button
                          className="absolute bottom-5 right-5 font-normal bg-white/100 text-black text-[12px]"
                          variant="functionWeak"
                          onClick={() => {
                            if (center != null) {
                              window.open(
                                `https://www.google.com/maps/search/?api=1&query=${center.lat},${center.lng}`,
                                '_blank'
                              )
                            }
                          }}
                        >
                          地図アプリで見る
                        </Button>
                      </Map>
                    </Wrapper>
                  </div>
                </div>
              )}
            <div className="m-5">
              <h3 className="font-bold text-sm">住所</h3>
              <p className="font-normal text-sm mt-2">
                {props.restaurant.address}
              </p>
              <h3 className="font-bold text-sm mt-3">アクセス情報</h3>
              <p className="font-normal text-sm mt-2">
                {props.restaurant.transportation}
              </p>
            </div>
          </>
        )}
      </div>
      <Footer />
    </>
  )
}

export const getServerSideProps: GetServerSideProps<Props> = async (
  context
) => {
  let restaurantId = context.query.id as string
  const restaurantResponse = await restaurantGetRestaurant({
    searchParams: { restaurant_id: restaurantId },
  })
  const props = {
    restaurant: restaurantResponse.restaurant,
  }
  return { props }
}

export default Page
